import BulkExportCultureMetadata from './BulkExportCultureMetadata'

const BulkExportCultureMetadataPage = () => {
  return <BulkExportCultureMetadata />
}

export default BulkExportCultureMetadataPage
